<template>
  <div class="sc-sub-header">
    <div
      class="sc-sub-icon"
      :style="{ background: bgIcon, color: bgColor }"
    >
      <slot></slot>
    </div>
    <div>
      <div class="sc-sub-title">
        {{ title }}
        <sup v-if="optional" class="fs-12 text-muted">(opcional)</sup>
      </div>
      <div class="sc-sub-desc">{{ description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubHeaderSection',
  props: {
    title: {
      type: String,
      required: true
    },
    optional: {
      type: Boolean,
      default: false
    },
    description: { type: String },
    bgIcon: { type: String, default: '#dddcdc' },
    bgColor: { type: String, default: '#e8380d' }
  }
}
</script>

<style scoped>
  .sc-sub-header { display: flex; align-items: center; gap: 12px; padding: 0px 24px 10px; }
  .sc-sub-icon { width: 42px; height: 42px; border-radius: 7px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 2px; }
  .sc-sub-title { line-height: 14px; }
  .sc-sub-desc { font-size: 0.8rem; color: #999; margin-top: 2px; }


  @media (max-width: 640px) {
    .sc-sub-header { padding-left: 16px; padding-right: 16px; }
  }
</style>
